import React, {useState, useEffect} from 'react'
import {fetchData} from '../Utils/FetchData'
import {useGlobalContext} from '../Utils/ContextApi';
import Loading from '../Utils/Loading';
import {tvMenuData} from '../Utils/Moviemenu'
import Pagination from '@mui/material/Pagination';
import TvCard from '../components/MovieCard/TvCard';
import Form from '../components/Form/TvForm'

function Tvshow(props) {

  const [tv, setTv] = useState([])
  const [tvMenu, setTVMenu] = useState(tvMenuData)
  const [tvType, setTvType] = useState('popular')
  const [currentPage, setCurrentPage] = React.useState(1)
  const {isLoading, setIsLoading} = useGlobalContext()

 
  useEffect(()=>{
    const tvShows = async () =>{
      let menu =[]
      try{
        setIsLoading(true)
      if(tvType === 'top rated'){
      menu = await fetchData(`https://api.themoviedb.org/3/tv/top_rated?api_key=${process.env.REACT_APP_API_KEY}&page=${currentPage}`)
      
      }else if(tvType === 'now playing'){
       menu = await fetchData(`https://api.themoviedb.org/3/tv/on_the_air?api_key=${process.env.REACT_APP_API_KEY}&page=${currentPage}`)
      }else{
        menu = await fetchData(`https://api.themoviedb.org/3/tv/popular?api_key=${process.env.REACT_APP_API_KEY}&page=${currentPage}`)
      }
      setIsLoading(false)
      setTv(menu)
    }catch(error){
      console.log(error)
    }
  }
    tvShows()
    
  }, [tvType, currentPage])
 
  const paginate = (e, value) => {
    setCurrentPage(value)
    // to take it back to the top with each new value
    window.scrollTo({top: 0, behavior: 'smooth'})
}
  return(
    <div>
  {isLoading? <Loading /> :   
    <div>
      <Form />
     <div className='btn-container'>
        {tvMenuData.map((item, index)=>{
        return(
        <button onClick={()=>setTvType(item)}className='btnn'style={{
          background:item===tvType? '#1976d2' : ''
        }} key={index}>{item}</button>
      )
    })}
    </div>
    <div className='card-container'>
      {tv.map((item, index)=>{
      return(
      <TvCard {...item} key={index}/>
      )
    })}
    </div>
    <Pagination shape='rounded' color='primary'
                    defaultPage={1}
                    page={currentPage}
                    count={
                        Math.ceil(40)
                    }
                    onChange={paginate} 
                    style={{display:"flex", justifyContent:"center",
                    margin:"20px 0"}}/>
    </div>
  }
  </div>
  )
}

export default Tvshow